import { PAGE_PROPERTIES } from "GlobalConstant/";
import { isMediaPropertyAvailable } from "GlobalUtils/MediaCampaign";

export const getStateFromProps = props => {
  const {
    comparisons,
    expertReviews,
    launchedCars,
    makeList,
    news,
    popularCars,
    popularUsedStocks,
    pQPlaceHolder,
    topBodyStyles,
    upcomingCars,
    videos,
    searchType,
    newCarPlaceHolder,
    searchExample,
    campaignTemplates,
    luxuryCarsCardDetails,
    hiddenAdUnitIds,
    userLocation,
  } = props || {};
  return {
    comparisons: comparisons || [],
    expertReviews: expertReviews || [],
    launchedCars: launchedCars || [],
    makeList: makeList || [],
    news: news || [],
    popularCars: popularCars || [],
    popularUsedStocks: popularUsedStocks || [],
    pQPlaceHolder: pQPlaceHolder || {},
    topBodyStyles: topBodyStyles || [],
    upcomingCars: upcomingCars || [],
    videos: videos || [],
    searchType,
    newCarPlaceHolder,
    searchExample,
    campaignTemplates,
    luxuryCarsCardDetails,
    hiddenAdUnitIds,
    userLocation,
    isHomePageBannerAvailable: isMediaPropertyAvailable(
      campaignTemplates,
      PAGE_PROPERTIES.Banner
    ),
    isSpecialFeatureAvailable: isMediaPropertyAvailable(
      campaignTemplates,
      PAGE_PROPERTIES.SpecialFeature
    ),
    isPqBannerAvailable: isMediaPropertyAvailable(
      campaignTemplates,
      PAGE_PROPERTIES.PQBanner
    ),
    isFirstWidgetAvailable: isMediaPropertyAvailable(
      campaignTemplates,
      PAGE_PROPERTIES.FirstWidget
    ),
    isSecondWidgetAvailable: isMediaPropertyAvailable(
      campaignTemplates,
      PAGE_PROPERTIES.SecondWidget
    ),
    isThirdWidgetAvailable: isMediaPropertyAvailable(
      campaignTemplates,
      PAGE_PROPERTIES.ThirdWidget
    ),
    isFourthWidgetAvailable: isMediaPropertyAvailable(
      campaignTemplates,
      PAGE_PROPERTIES.FourthWidget
    ),
  };
};

export const mapStateToProps = state => {
  const { homePage, location } = state;
  return {
    ...getStateFromProps(homePage),
    globalLocation: location,
  };
};

export const setUsedCarSearchInitialState = props => {
  const { globalLocation } = props;
  const { cityId, cityName } = globalLocation;
  return {
    text: cityId > 0 && cityName ? cityName : "",
    results: [],
    cityId,
    cityMaskingName: "",
    isPriceRangeSelectorVisible: cityId > 0,
    priceRangeText: "Choose your Budget",
    lowerBudgetLimit: "",
    upperBudgetLimit: "",
    lowerBudgetValidation: true,
    upperBudgetValidation: true,
  };
};
